import React from 'react';

import ClickEventLoggerWrapper from '@/components/common/ClickEventLogWrapper';
import InfiniteScroll from '@/components/common/infinite-scroll';
import LinkTag from '@/components/common/link-tag';
import HospitalSkeletonList from '@/components/templates/f2f/common/hospital-list/hospital-skeleton-list';
import { DiseaseEncyclopedia } from '@/entities/disease-encyclopedia';
import { createDiseaseEncyclopediaDetailUrlWithKeyword } from '@/entities/disease-encyclopedia/util';
import { SearchDiseaseEncyclopediaViewModel } from '@/hooks/search/disease-encyclopedia/useSearchDiseaseEncyclopediaViewModel';
import EmptySearchResult from '../empty-search-result';

interface Props {
  diseaseEncyclopediaViewModel: SearchDiseaseEncyclopediaViewModel;
}

const DiseaseEncyclopediaSearchResult = ({ diseaseEncyclopediaViewModel }: Props) => {
  if (diseaseEncyclopediaViewModel.isDiseaseEncyclopediaLoading) {
    return <HospitalSkeletonList />;
  }

  if (!diseaseEncyclopediaViewModel.diseaseEncyclopedia.length) {
    return <EmptySearchResult handleClickRequestButton={diseaseEncyclopediaViewModel.handleClickRequestButton} />;
  }

  return (
    <>
      <InfiniteScroll
        rootMargin={'0px 0px 0px 100px'}
        isLoading={diseaseEncyclopediaViewModel.isDiseaseEncyclopediaLoading}
        hasNextPage={diseaseEncyclopediaViewModel.hasDiseaseEncyclopediaNextPage}
        fetchNextPage={diseaseEncyclopediaViewModel.fetchDiseaseEncyclopediaNextPage}
      >
        <div className='[&>*:not(:last-child)>div]:border-gray-200 [&>*:not(:last-child)>div]:border-b'>
          {diseaseEncyclopediaViewModel.diseaseEncyclopedia.map((diseaseEncyclopedia, index) => (
            <ClickEventLoggerWrapper
              key={`diseaseEncyclopedia_${diseaseEncyclopedia.getPublicId()}`}
              onClickEventLog={() =>
                diseaseEncyclopediaViewModel.onClickLogDiseaseEncyclopedia(diseaseEncyclopedia.getPublicId())
              }
            >
              <>
                <div className='flex flex-col gap-[12px] p-[24px]'>
                  <LinkTag
                    href={createDiseaseEncyclopediaDetailUrlWithKeyword(
                      diseaseEncyclopedia.getPublicId(),
                      diseaseEncyclopediaViewModel.keyword
                    )}
                    onClickNavigateToScreen={diseaseEncyclopediaViewModel.onClickDiseaseEncyclopedia(
                      diseaseEncyclopedia.getPublicId()
                    )}
                  >
                    <DiseaseEncyclopedia
                      title={diseaseEncyclopedia.getTitle()}
                      summary={diseaseEncyclopedia.getContent()}
                      image={diseaseEncyclopedia.getTitleImageUrl() ?? undefined}
                      imageAlt={diseaseEncyclopedia.getTitle()}
                    />
                  </LinkTag>
                </div>
                {index !== diseaseEncyclopediaViewModel.diseaseEncyclopedia.length - 1 && (
                  <div className='h-[1px] w-full bg-gray-40' />
                )}
              </>
            </ClickEventLoggerWrapper>
          ))}
        </div>
      </InfiniteScroll>
    </>
  );
};

export default DiseaseEncyclopediaSearchResult;
